import React, { useEffect, useState } from "react";
import moment from "moment";
import GlobalNav from "../components/GlobalNav";
import EventCard from "../components/EventCard";
import Footer from "../components/Footer";
import Calendar from "../components/Calendar";
import "../styles/buttons.css";
import "./EventsPage.css";

const GET_INVOLVED = [
  { label: "Get on the email list", href: "#subscribe", primary: true },
  { label: "Join the media crew", href: "https://docs.google.com/forms/d/e/1FAIpQLSd1sxWEL_b1ArSmlGQrklKnH15iyu8F6AUGOeKajpwDRRY1GQ/viewform" },
  { label: "Perform with us", href: "https://docs.google.com/forms/d/e/1FAIpQLSd1sxWEL_b1ArSmlGQrklKnH15iyu8F6AUGOeKajpwDRRY1GQ/viewform" },
  { label: "Host at your venue", href: "https://docs.google.com/forms/d/e/1FAIpQLSc6ey758aVG3jtfekHWMsWHXHH9eAZs4kKivEf2JpCmtpIweQ/viewform" },
  { label: "Bring us to your city", href: "https://airtable.com/appmdUAku7mfmhD9x/pagURHxA52v5OBGDN/form" },
  { label: "Contact us", href: "mailto:musicishealingus@gmail.com" },
];

const CALENDAR_URL =
  "https://calendar.google.com/calendar/embed?src=musicishealingus%40gmail.com&ctz=America%2FNew_York";

function splitEvents(rows) {
  const today = moment().startOf("day");
  const upcoming = [];
  const past = [];
  rows.forEach((e) => {
    const d = moment(e.day);
    if (!d.isValid() || d.isBefore(today)) past.push(e);
    else upcoming.push(e);
  });
  past.reverse();
  return { upcoming, past };
}

function eventToCardProps(event) {
  const d = moment(event.day);
  return {
    month: d.isValid() ? d.format("MMM") : "—",
    day: d.isValid() ? d.format("D") : event.day,
    title: event.title,
    time: event.time || "",
    location: event.city || "",
  };
}

export default function EventsPage() {
  const [filter, setFilter] = useState("upcoming");
  const [events, setEvents] = useState(null);

  useEffect(() => {
    fetch("/api/events")
      .then((r) => r.json())
      .then((data) => {
        // GET /api/events returns { upcoming, past, all } —
        // already split server-side using the same moment(event.day)
        // logic so we don't need to re-split client-side.
        if (data.upcoming !== undefined) {
          setEvents({ upcoming: data.upcoming, past: data.past });
        } else {
          // fallback: plain array (older shape)
          const rows = Array.isArray(data) ? data : [];
          setEvents(splitEvents(rows));
        }
      })
      .catch((err) => console.error("Error fetching events:", err));
  }, []);

  const upcoming = events?.upcoming ?? [];
  const past = events?.past ?? [];
  const loading = events === null;

  const showUpcoming = filter !== "past";
  const showPast = filter !== "upcoming";

  return (
    <div className="events-page">
      <GlobalNav activeHref="/events" ctaLabel="Join the collective" />

      {/* <div className="events-hero">
        <div className="events-hero-inner">
          <div className="events-hero-eyebrow">What's happening</div>
          <h1 className="events-hero-title">Events</h1>
          <p className="events-hero-sub">Community gatherings, shows, and sessions</p>
        </div>
        <div className="events-filters">
          {["all", "upcoming", "past"].map((key) => (
            <button
              key={key}
              className={"events-filter-btn" + (filter === key ? " active" : "")}
              onClick={() => setFilter(key)}
            >
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </button>
          ))}
        </div>
      </div> */}

      {/* <div className="events-body">
        {loading && <p className="events-loading">Loading events…</p>}

        {!loading && showUpcoming && (
          <>
            <div className="events-section-label">Upcoming</div>
            {upcoming.length > 0 ? (
              <div className="events-grid">
                {upcoming.map((ev) => (
                  <EventCard key={ev.id} {...eventToCardProps(ev)} ctaLabel={ev.link ? "Details" : undefined} onCtaClick={ev.link ? () => window.open(ev.link, "_blank") : undefined} />
                ))}
              </div>
            ) : (
              <p className="events-empty">No upcoming events right now — check back soon.</p>
            )}
          </>
        )}

        {!loading && showPast && past.length > 0 && (
          <>
            <div className="events-section-label">Past</div>
            <div className="events-past-list">
              {past.map((ev) => (
                <div className="events-past-row" key={ev.id}>
                  <span className="events-past-date">
                    {moment(ev.day).isValid() ? moment(ev.day).format("MMM D, YYYY") : ev.day}
                  </span>
                  <span className="events-past-title">{ev.title}</span>
                  <span className="events-past-location">{ev.city}</span>
                </div>
              ))}
            </div>
          </>
        )}

        <a className="events-calendar-link" href={CALENDAR_URL} target="_blank" rel="noopener noreferrer">
          + Add to your calendar
        </a>
      </div> */}

      <section className="events-calendar-section">
        {/* <div className="events-section-label events-calendar-section-label">Full schedule</div> */}
        <Calendar />
      </section>

      {/* Road Show & Media Tour promo */}
      <section className="tour-promo">
        <div className="tour-promo-inner">
          <div className="tour-promo-media">
            <img className="tour-promo-image-placeholder" src="images/FreetimeRadioLogo.png" alt="Freedom Hour Radio" />
            <div className="tour-promo-host">Hosted by KWE</div>
          </div>
          <div className="tour-promo-copy">
            <div className="tour-promo-eyebrow">Freedom Hour Radio</div>
            <h2 className="tour-promo-title">Road Show &amp; Media Tour</h2>
            <p className="tour-promo-sub">
              Live-in-studio performances with poets, singers, and players of
              instruments of the Music Is Healing crew.
            </p>
          </div>
        </div>

        <div className="tour-promo-cta-block">
          <div className="events-section-label tour-promo-cta-label">Get involved</div>
          <div className="tour-promo-ctas">
            {GET_INVOLVED.map((cta) => (
              <a
                key={cta.label}
                href={cta.href}
                target={cta.href.startsWith("http") ? "_blank" : undefined}
                rel={cta.href.startsWith("http") ? "noopener noreferrer" : undefined}
                className={cta.primary ? "mihu-btn-primary-lg" : "mihu-btn-secondary-lg on-dark"}
              >
                {cta.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
